// Module
var code = " <filter-box data-ref=filterBox></filter-box> <ul data-ref=list></ul> <template data-ref=empty> <li class=empty> <h4>No more matches :(</h4> <button class=clear-button>Clear filters</button> </li> </template>";
// Exports
export default code;